import React from "react";
import "../css/Job_detail_popup.css";
import ic_signature_user from "../img/ic_signature_user.png";
import ic_next_item from "../img/ic_next_item.png";
import ic_previous_item from "../img/ic_previous_item.png";

function Job_detail_popup(props) {

    const { jobDetailArrayState, closeJobPopup, swiped, startingJobNumber, endJobNumber } = props;
    console.log("jobDetailArray ", jobDetailArrayState);



    return (
        <div className="Job_detail_popup_wrapper_container">

            <div className="Job_detail_popup_header_container">
                <div><h5 className="me-4">Job Details</h5> {jobDetailArrayState[0].JOB_NO}</div>

                <button onClick={closeJobPopup} className="common_close_button">Close</button>
            </div>

            <div className="Job_detail_popup_root_container">

                {
                    jobDetailArrayState != null ?
                        jobDetailArrayState.length > 0 ?
                            <div className="Job_detail_popup_details_container">
                                <div className="Job_detail_popup_details_top_container">
                                    <div className="CreateNewJob-customer-personal-and-car-details">
                                        <div className="CreateNewJob-customer-label-and-values">
                                            <label className="common_style_label">Customer Name</label>
                                            <label className="common_style_value">{jobDetailArrayState[0].accdesc}</label>
                                        </div><div className="CreateNewJob-customer-label-and-values">
                                            <label className="common_style_label">Mobile Number</label>
                                            <label className="common_style_value">{jobDetailArrayState[0].mobileno}</label></div>
                                        <div className="CreateNewJob-customer-label-and-values">
                                            <label className="common_style_label">Address</label>
                                            <label className="common_style_value">{jobDetailArrayState[0].adr}</label>
                                        </div>
                                        <div className="CreateNewJob-customer-label-and-values ">
                                            <label className="common_style_label">Car Number</label>
                                            <label className="common_style_value">{jobDetailArrayState[0].plate_no}</label>
                                        </div>
                                        {
                                            // LOYALTY_PROGRAM
                                            process.env.REACT_APP_ENABLE_LOYALTY_PROGRAM == "true" ?
                                                <div className="CreateNewJob-customer-label-and-values ">
                                                    <label className="common_style_label">Loyalty Category</label>
                                                    <label className="common_style_value">{jobDetailArrayState[0].TYPE}</label>
                                                </div>
                                                :
                                                null
                                        }
                                        <div className="CreateNewJob-customer-label-and-values">
                                            <label className="common_style_label">Chassis Number</label>
                                            <label className="common_style_value">{jobDetailArrayState[0].CHASSIS}</label>
                                        </div>
                                        <div className="CreateNewJob-customer-label-and-values">
                                            <label className="common_style_label">Model</label>
                                            <label className="common_style_value">{jobDetailArrayState[0].MODEL}</label>
                                        </div>
                                        <div className="CreateNewJob-customer-label-and-values">
                                            <label className="common_style_label">Make</label>
                                            <label className="common_style_value">{jobDetailArrayState[0].make}</label>
                                        </div>
                                        <div className="CreateNewJob-customer-label-and-values">
                                            <label className="common_style_label">Year</label>
                                            <label className="common_style_value">{jobDetailArrayState[0].YEAR}</label>
                                        </div>
                                        <div className="CreateNewJob-customer-label-and-values">
                                            <label className="common_style_label">Odometer reading</label>
                                            <label className="common_style_value">{jobDetailArrayState[0].MILEAGE}</label>
                                        </div>
                                        <div className="CreateNewJob-customer-label-and-values">
                                            <label className="common_style_label">Fuel meter reading</label>
                                            <label className="common_style_value">{jobDetailArrayState[0].FUELLEVEL}</label>
                                        </div>
                                        <div className="CreateNewJob-customer-label-and-values">
                                            <label className="common_style_label">Technicians assigned</label>
                                            <label className="common_style_value">{
                                                jobDetailArrayState[0].assigned
                                            }</label>
                                        </div>
                                        {
                                            // LOYALTY_PROGRAM
                                            process.env.REACT_APP_ENABLE_LOYALTY_PROGRAM == "true" ?
                                                <>
                                                    <div className="CreateNewJob-customer-label-and-values">
                                                        <label className="common_style_label">Points Available</label>
                                                        <label className="common_style_value">{jobDetailArrayState[0].points_available}</label>
                                                    </div>
                                                    <div className="CreateNewJob-customer-label-and-values">
                                                        <label className="common_style_label">Points Earned</label>
                                                        <label className="common_style_value">{jobDetailArrayState[0].points_earned}</label>
                                                    </div>
                                                    <div className="CreateNewJob-customer-label-and-values">
                                                        <label className="common_style_label">Points Redeemed</label>
                                                        <label className="common_style_value">{jobDetailArrayState[0].points_redeemed}</label>
                                                    </div>
                                                </>
                                                :
                                                null
                                        }
                                    </div>
                                </div>
                                <div className="Job_detail_popup_details_bottom_container">
                                    <div className="CreateNewJob-service-list-table-container-wrapper Confirm_job_popup_service_list_table_container_wrapper py-2">
                                        <div className="CreateNewJob-service-list-table-container Confirm_job_popup_service_list_table_container">
                                            <table className="CreateNewJob-service-list-table Confirm_job_popup_service_list_table">
                                                <thead>
                                                    <tr>
                                                        <th><div className="CreateNewJob-sl-no-container">Sl. No.</div></th>
                                                        <th><div>Service Code</div></th>
                                                        <th><div>Description</div></th>
                                                        {
                                                            // LOYALTY_PROGRAM
                                                            process.env.REACT_APP_ENABLE_LOYALTY_PROGRAM == "true" ?
                                                                <th><div>Points</div></th>
                                                                :
                                                                null
                                                        }
                                                        {/* <th><div>Unit</div></th> */}
                                                        <th><div>Qty</div></th>
                                                        <th><div>Price</div></th>
                                                        <th><div>Amount</div></th>

                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {
                                                        jobDetailArrayState.map((item, index) => {
                                                            return (
                                                                <tr>
                                                                    <td><div>{index + 1}</div></td>
                                                                    <td><div>{item.CODE}</div></td>
                                                                    <td><div>{item.DESCRIPTION}</div></td>
                                                                    {
                                                                        // LOYALTY_PROGRAM
                                                                        process.env.REACT_APP_ENABLE_LOYALTY_PROGRAM == "true" ?
                                                                            <td><div>{item.table_row_template_points}</div></td>
                                                                            :
                                                                            null
                                                                    }
                                                                    {/* <td><div>{item.table_row_template_unit}</div></td> */}
                                                                    <td><div>{item.QTY}</div></td>
                                                                    <td><div>{item.PRICE}</div></td>
                                                                    <td><div>{item.AMOUNT}</div></td>

                                                                </tr>
                                                            )
                                                        })
                                                    }


                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div className="JobDetails-signature-signature-box-heading JobDetails-signature-section mt-3">
                                    <div><img src={ic_signature_user} />
                                        <label>Customer Signature</label>
                                    </div>
                                    <div className="JobDetails-signature-signature-container">
                                        <img src={jobDetailArrayState[0].customer_signature} />
                                    </div>
                                </div>

                            </div>
                            :
                            null
                        :
                        null
                }

                {
                    startingJobNumber != jobDetailArrayState[0].JOB_NO &&
                    < img className="swipe-left-icon" src={ic_previous_item} onClick={() => swiped("left")} />
                }

                {
                    endJobNumber != jobDetailArrayState[0].JOB_NO &&
                    <img className="swipe-right-icon" src={ic_next_item} onClick={() => swiped("right")} />
                }



            </div>


        </div>
    )
}

export default Job_detail_popup;